import SystemSettingsTemplate from "components/templates/SystemSettingsTemplate/SystemSettingsTemplate";

export default function SystemSettingsPage() {
  return <SystemSettingsTemplate />;
}
